import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toolbar, AppBar, Typography, Button } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AppState from '../../../models/redux/state/app.state';
import { logoutAPIcall } from '../../../redux/actions/auth/auth.actions';
import history from '../../../services/browserHistory';
import { white, yellowOrange } from '../../../app/theme';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    boxShadow: 'none',
    backgroundColor: theme.palette.lightBlueBackground?.main,
    height: 70,
  },
  topToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 70,
  },
  healthcare: {
    fontSize: 14,
    paddingLeft: 41,
    color: white,
    fontWeight: 600,
  },
  buttonsContainer: {
    height: '100%',
    display: 'flex',
    alignSelf: 'flex-end',
    alignItems: 'center',
    '& > div::after': {
      content: '""',
      height: '1em',
      display: 'inline-block',
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      borderRight: `2px solid ${yellowOrange}`,
      margin: '0 0.25em',
    },
    '& > div:last-child::after': {
      display: 'none',
    },
  },
  rightSideButtons: {
    textTransform: 'none',
    color: white,
    fontWeight: 600,
  },
}));

const HomeNavBar = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const auth = useSelector((state: AppState) => state.auth);

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar className={classes.topToolbar}>
        <Typography className={classes.healthcare}>
          <em>FOR US HEALTHCARE PROFESSIONALS</em>
        </Typography>
        {auth.user && (
          <div className={classes.buttonsContainer}>
            {auth.user?.isAdmin && (
              <div>
                <Button
                  className={classes.rightSideButtons}
                  onClick={() => history.push('/admin', { from: history.location.pathname })}
                  color="inherit"
                >
                  Admin Portal
                </Button>
              </div>
            )}
            <div>
              <Button className={classes.rightSideButtons} onClick={() => history.push('/profile')} color="inherit">
                My Profile
              </Button>
            </div>
            <div>
              <Button className={classes.rightSideButtons} onClick={() => dispatch(logoutAPIcall())} color="inherit">
                Log Out
              </Button>
            </div>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default HomeNavBar;
